<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<!-- Information Show -->
<div class="m-0 clientOuterDiv" *ngIf="IsDisabled">

  <!-- Left Column: Borrower Profile Card -->
  <div class="leftPart" *ngIf="IsDisabled">
    <div class="profile-avatar-container" (click)="ProfilePicFullmodel()">
      <img src="{{ CustomerPicDetail }}" alt="Profile Pic" />
    </div>

    <div>
      <div class="profile-name">{{ customerData?.Customer }}</div>
      <div class="profile-relation">{{ customerData?.Relation_Name }}</div>
    </div>

    <div class="profile-info-list">
      <!-- Mobile No -->
      <div class="profile-info-item">
        <i class="fa fa-phone info-icon"></i>
        <div class="info-content">
          <div class="info-label">Mobile No.</div>
          <div class="info-value text-primary">
            <span *ngIf="currentUser.IsMaskingMobile">{{ customerData?.PhoneNo | mask }}</span>
            <span *ngIf="!currentUser.IsMaskingMobile">{{ customerData?.PhoneNo }}</span>
          </div>
        </div>
      </div>

      <!-- Email ID -->
      <div class="profile-info-item">
        <i class="fa fa-envelope info-icon"></i>
        <div class="info-content">
          <div class="info-label">Email Id</div>
          <div class="info-value text-primary">
            <span *ngIf="currentUser?.IsMaskingMobile">{{ customerData?.Customer_Email ? (customerData?.Customer_Email |
              emailmask) : "Nil" }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ customerData?.Customer_Email ?
              customerData?.Customer_Email : "Nil" }}</span>
          </div>
        </div>
      </div>

      <!-- Present Address -->
      <div class="profile-info-item">
        <i class="fa-solid fa-location-dot info-icon"></i>
        <div class="info-content">
          <div class="info-label">Present Address</div>
          <div class="info-value">
            {{ CustomerAddress?.Present_Address || '-' }}
          </div>
        </div>
      </div>

      <!-- Permanent Address -->
      <div class="profile-info-item">
        <i class="fa-solid fa-location-dot info-icon"></i>
        <div class="info-content">
          <div class="info-label">Permanent Address</div>
          <div class="info-value">
            {{ CustomerAddress?.Permanent_Address || '-' }}
          </div>
        </div>
      </div>
    </div>

    <div class="profile-actions">
      <button type="button" (click)="viewCustomerDetails()" class="btn-outline-brand">
        View Details
      </button>
    </div>
  </div>

  <!-- Right Column: Details Cards -->
  <div class="rightPart" *ngIf="IsDisabled">
    <div class="details-card">
      <div class="card-header-container">
        <h3 class="card-title-text">Loan Details</h3>
      </div>

      <div class="details-grid">
        <div class="details-field">
          <span class="field-label">Branch</span>
          <span class="field-value">{{ loanInfoModel.Branch || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Branch Head</span>
          <span class="field-value">{{ loanInfoModel.BranchHeadName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Loan Product</span>
          <span class="field-value">{{ loanInfoModel.Product || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Source Type</span>
          <span class="field-value">{{ loanInfoModel.SourceType || '-' }}</span>
        </div>

        <!-- Dynamic Source Name -->
        <div class="details-field" *ngIf="
             loanInfoModel.SelectSourceType == 'Agent' ||
             loanInfoModel.SelectSourceType == 'DSA' ||
             loanInfoModel.SelectSourceType == 'Dealer' ||
             loanInfoModel.SelectSourceType == 'Sales Executive' ||
             loanInfoModel.SelectSourceType == 'Telecaller Executive' ||
             loanInfoModel.SelectSourceType == 'Marketing Executive'
           ">
          <span class="field-label">Source Name</span>
          <span class="field-value">{{ loanInfoModel.Partner_Name || '-' }}</span>
        </div>
        <div class="details-field" *ngIf="
             loanInfoModel.SelectSourceType == 'Reference' ||
             loanInfoModel.SelectSourceType == 'Social Media'
           ">
          <span class="field-label">Source Name</span>
          <span class="field-value">{{ loanInfoModel.LeadReference || '-' }}</span>
        </div>

        <div class="details-field">
          <span class="field-label">Source Area</span>
          <span class="field-value">{{ loanInfoModel.SourceAreaName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Sales Executive</span>
          <span class="field-value">{{ loanInfoModel.SalesExecutiveName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Collection Executive</span>
          <span class="field-value">{{ loanInfoModel.CollectionExecutiveName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Collection Area</span>
          <span class="field-value">{{ loanInfoModel.AreaName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Collection Sub Area</span>
          <span class="field-value">{{ loanInfoModel.SubareaName || '-' }}</span>
        </div>
        <div class="details-field">
          <span class="field-label">Loan Purpose</span>
          <span class="field-value">{{ loanInfoModel.LoanPurpose || '-' }}</span>
        </div>
      </div>
    </div>

    <!--TAT Report Card-->
    <div class="details-card" *ngIf="dataSourceDetail?.data.length">
      <div class="card-header-container">
        <h3 class="card-title-text">TAT Report</h3>
      </div>

      <div class="table-responsive">
        <mat-table #TATTable [dataSource]="dataSourceDetail" matSort
          style="height: 25rem; max-width: 100%; overflow: auto">
          <ng-container matColumnDef="ProcessId">
            <mat-header-cell mat-sort-header class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem">
              {{ i + 1 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Process">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Process</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Process }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ProcessExecutive">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Executive
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ProcessExecutive }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ProcessStatus">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef style="min-width: 11.875rem">
              Status
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell text-center" style="min-width: 11.875rem">
              <span *ngIf="row.ProcessStatus === 'Pending'" class="status-badge pending">Pending</span>
              <span *ngIf="row.ProcessStatus === 'Sendback'" class="status-badge Sendback">Sendback</span>
              <span *ngIf="row.ProcessStatus === 'SendBackReverted'"
                class="status-badge SendBackReverted">SendBackReverted</span>
              <span *ngIf="row.ProcessStatus === 'Reverted'" class="status-badge reverted">Reverted</span>
              <span *ngIf="
                   row.ProcessStatus !== 'Pending' &&
                   row.ProcessStatus !== 'Reverted' &&
                   row.ProcessStatus !== 'Sendback' &&
                   row.ProcessStatus !== 'SendBackReverted'
                 ">
                {{ row.ProcessStatus }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="AssignedOn">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Assign On</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.AssignedOn }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="CompletedOn">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Completed On</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.CompletedOn }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="TAT_Hr">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              TAT (Hrs)
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.TAT_Hr
              }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Maximum_Standard_Tat">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Max TAT (Hrs)
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Maximum_Standard_Tat }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="TAT_Status">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              TAT Status
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell" [ngStyle]="{
                 color:
                   row.TAT_Status && row.TAT_Status.toLowerCase().includes('delayed')
                     ? 'red'
                     : ''
               }">
              {{ row.TAT_Status }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Remark">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              Remark
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Remark }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="LatLong">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
              LatLong
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              <a target="_blank" *ngIf="row.LatLong != '' && row.LatLong != null && row.LatLong != ','"
                [href]="'http://maps.google.com/maps?q=' + row.LatLong">
                <i class="fa-solid fa-location-dot"></i>
              </a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedDetailColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedDetailColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>

<!--Form To Edit Information-->
<!-- <form #f="ngForm" class="col-md-12 formborder" novalidate>
  <div style="max-height: fit-content; max-width: 100%; overflow: auto">
    <div class="row m-0 mt-2" *ngIf="!IsDisabled">
      <div class="col-md-3 p-1">
        <span class="required-lable"> Branch </span>
        <select name="Branch_Id" (change)="getAppNo_AND_LoanNo()" id="Branch_Id" #refBranch_Id="ngModel" required
          [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refBranch_Id.invalid,
            'alert-warning':
              refBranch_Id.invalid &&
              (refBranch_Id.dirty ||
                refBranch_Id.touched ||
                refBranch_Id.untouched)
          }" [(ngModel)]="loanInfoModel.Branch_Id" class="form-control input-text-css">
          <option value="">Select Branch</option>
          <option *ngFor="let branch of BranchesList" [value]="branch.BranchId" (onSelect)="onSelectMethods($event)">
            {{ branch.Branch_Name }}
          </option>
        </select>
      </div>
      <div class="col-md-3 p-1">
                <span class="required-lable">Application No </span>
                <input name="ApplicationNo" id="ApplicationNo" #refApplicationNo="ngModel" disabled [(ngModel)]="loanInfoModel.ApplicationNo" readonly
                    placeholder="ApplicationNo" class="form-control input-text-css">
            </div> 
      <div class="col-md-3 p-1">
        <span class="required-lable"> Branch Head </span>
        <select name="SelectBranchHead" id="SelectBranchHead" #refSelectBranchHead="ngModel" required [ngClass]="{
            'is-invalid': f.submitted && refSelectBranchHead.invalid,
            'alert-warning':
              refSelectBranchHead.invalid &&
              (refSelectBranchHead.dirty ||
                refSelectBranchHead.touched ||
                refSelectBranchHead.untouched)
          }" [(ngModel)]="loanInfoModel.SelectBranchHead" class="form-control input-text-css" disabled>
          <option value="">Select Branch Head</option>
          <option *ngFor="let head of branchHeadData" [value]="head.EmpId">
            {{ head.Emp_FirstName + " " + head.Emp_LastName }}
          </option>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span class="required-lable"> Loan Product </span>
        <select name="LoanProduct_Id" id="LoanProduct_Id" #refLoanProduct_Id="ngModel" required [disabled]="IsDisabled"
          (change)="getAppNo_AND_LoanNo()" [ngClass]="{
            'is-invalid': f.submitted && refLoanProduct_Id.invalid,
            'alert-warning':
              refLoanProduct_Id.invalid &&
              (refLoanProduct_Id.dirty ||
                refLoanProduct_Id.touched ||
                refLoanProduct_Id.untouched)
          }" [(ngModel)]="loanInfoModel.LoanProduct_Id" class="form-control input-text-css">
          <option value="">Select Products</option>
          <ng-container *ngFor="let productg of ProductList">
            <option *ngIf="productg.Product_IsActive == true" [value]="productg.ProductId">
              {{ productg.Product }}
            </option>
          </ng-container>
        </select>
      </div>

      <div class="col-md-3 p-1">
        <span class="required-lable">Source Type </span>
        <select name="SelectSourceType" id="SelectSourceType" #refSelectSourceType="ngModel" required
          [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refSelectSourceType.invalid,
            'alert-warning':
              refSelectSourceType.invalid &&
              (refSelectSourceType.dirty ||
                refSelectSourceType.touched ||
                refSelectSourceType.untouched)
          }" (change)="Get_PartnerForDropdown()" [(ngModel)]="loanInfoModel.SelectSourceType"
          class="form-control input-text-css">
          <option value="">Select Source Type</option>
          <option *ngFor="let lead of leadSourceDropdown" [value]="lead.Lead_Source">
            {{ lead.Lead_Source_DisplayName }}
          </option>
        </select>
      </div>
      <ng-container *ngIf="
          loanInfoModel.SelectSourceType == 'Agent' ||
          loanInfoModel.SelectSourceType == 'DSA' ||
          loanInfoModel.SelectSourceType == 'Dealer' ||
          loanInfoModel.SelectSourceType == 'Sales Executive' ||
          loanInfoModel.SelectSourceType == 'Telecaller Executive' ||
          loanInfoModel.SelectSourceType == 'Marketing Executive'
        ">
        <div class="col-md-3 p-1">
          <span class="required-lable"> Source Name</span>
          <select name="LeadSourceName" id="LeadSourceName" #refLeadSourceName="ngModel" required
            [disabled]="IsDisabled" [ngClass]="{
              'is-invalid': f.submitted && refLeadSourceName.invalid,
              'alert-warning':
                refLeadSourceName.invalid &&
                (refLeadSourceName.dirty ||
                  refLeadSourceName.touched ||
                  refLeadSourceName.untouched)
            }" [(ngModel)]="loanInfoModel.LeadSourceName" class="form-control input-text-css">
            <option value="">Select Lead Reference</option>
            <option *ngFor="let partner of partnerDropdown" [value]="partner.PartnerId">
              {{ partner.Partner_Name }}
            </option>
          </select>
        </div>
      </ng-container>
      <ng-container *ngIf="
          loanInfoModel.SelectSourceType == 'Reference' ||
          loanInfoModel.SelectSourceType == 'Social Media'
        ">
        <div class="col-md-3 p-1">
          <span> Source Name</span>
          <input type="text" #refLeadReference="ngModel" [(ngModel)]="loanInfoModel.LeadReference"
            [disabled]="IsDisabled" placeholder="Lead Reference" name="LeadReference" id="LeadReference"
            class="form-control input-text-css" />
        </div>
      </ng-container>
      <div class="col-md-3 p-1">
        <span> Source Area</span>
        <select name="SelectSourceArea" id="SelectSourceArea" #refSelectSourceArea="ngModel" [disabled]="IsDisabled"
          [(ngModel)]="loanInfoModel.SelectSourceArea" class="form-control input-text-css">
          <option value="">Select Source Area</option>
          <ng-container *ngFor="let area of areaData">
            <option *ngIf="area.Type.trim() == 'Source Area'" [value]="area.Int_Id">
              {{ area.Area_Name }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span class="required-lable"> Sales Executive</span>
        <select name="SalesExecutive" id="SalesExecutive" #refSalesExecutive="ngModel" required
          (change)="onChangeSalesExecutive(loanInfoModel.SalesExecutive)" [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refSalesExecutive.invalid,
            'alert-warning':
              refSalesExecutive.invalid &&
              (refSalesExecutive.dirty ||
                refSalesExecutive.touched ||
                refSalesExecutive.untouched)
          }" [(ngModel)]="loanInfoModel.SalesExecutive" class="form-control input-text-css">
          <option value="">Select Sales Executive</option>
          <option *ngFor="let collection of SalesExecutiveData" [value]="collection.EmpId">
            {{ collection.EmpName }}
          </option>
        </select>
      </div>

      <div class="col-md-3 p-1">
        <span>Collection Executive</span>
        <select name="CollectionExecutive" id="CollectionExecutive" #refCollectionExecutive="ngModel"
          [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refCollectionExecutive.invalid,
            'alert-warning':
              refCollectionExecutive.invalid &&
              (refCollectionExecutive.dirty ||
                refCollectionExecutive.touched ||
                refCollectionExecutive.untouched)
          }" [(ngModel)]="loanInfoModel.CollectionExecutive" class="form-control input-text-css">
          <option value="">Select Collection Executive</option>
          <option *ngFor="let collection of CollectionExecutiveData" [value]="collection.EmpId">
            {{ collection.Emp_FirstName }}
          </option>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span> Collection Area</span>
        <select name="SelectArea" id="SelectArea" (change)="changeArea()" #refSelectArea="ngModel"
          [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refSelectArea.invalid,
            'alert-warning':
              refSelectArea.invalid &&
              (refSelectArea.dirty ||
                refSelectArea.touched ||
                refSelectArea.untouched)
          }" [(ngModel)]="loanInfoModel.SelectArea" class="form-control input-text-css">
          <option value="">Select Collection Area</option>
          <ng-container *ngFor="let area of areaData">
            <option *ngIf="area.Type.trim() == 'Collection Area'" [value]="area.Int_Id">
              {{ area.Area_Name }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span> Collection Sub Area</span>
        <select name="SelectSubarea" id="SelectSubarea" #refSelectSubarea="ngModel" [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refSelectSubarea.invalid,
            'alert-warning':
              refSelectSubarea.invalid &&
              (refSelectSubarea.dirty ||
                refSelectSubarea.touched ||
                refSelectSubarea.untouched)
          }" [(ngModel)]="loanInfoModel.SelectSubarea" class="form-control input-text-css">
          <option value="">Select Collection SubArea</option>
          <option *ngFor="let subarea of subAreaData" [value]="subarea.Int_Id">
            {{ subarea.Sub_Area_Name }}
          </option>
        </select>
      </div>
      <app-add-customer-info class="col-md-3" [TypeFrom]="TypeFrom" [loan_Summary]="loanSummary"
        [SelectedProductId]="loanInfoModel.LoanProduct_Id" (close)="GetData($event)" [digilockerSdk1]="digilockerSdk1"
        [sdkEventData]="sdkEventData" [digioSdk]="digioSdk" [digiosdkEventData]="digiosdkEventData"
        (click)="addCustomerLink()" [index]="999978465123102" [Heading]="'Add'" *ngIf="showAddCustomerButton
        ">
        <button type="button" class="mt-4 btn font-size-12 button-btn" [disabled]="!f.form.valid">
          Add Customer
        </button>
      </app-add-customer-info>
    </div>
    <div class="row m-0" *ngIf="!IsDisabled">
      <div class="col-md-12 p-1">
        <span class="required-lable"> Loan Purpose </span>
        <textarea [(ngModel)]="loanInfoModel.LoanPurpose" rows="3" maxlength="150" #refLoanPurpose="ngModel" required
          [disabled]="IsDisabled" [ngClass]="{
            'is-invalid': f.submitted && refLoanPurpose.invalid,
            'alert-warning':
              refLoanPurpose.invalid &&
              (refLoanPurpose.dirty ||
                refLoanPurpose.touched ||
                refLoanPurpose.untouched)
          }" placeholder="Loan Purpose" name="LoanPurpose" id="LoanPurpose"
          class="form-control input-text-css"></textarea>
      </div>
    </div>
    NAYA OTP POPUP
    <div class="row m-0 mt-2" *ngIf="PageData.currentTab == 1">
      <div class="modal fade in" id="OTPModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.6); overflow: auto">
        <div class="modal-dialog modal-dialog-centered modal-sm" role="document" style="max-width: 20rem;">
          <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content"
            style="border-radius: 0.75rem; border: none; box-shadow: 0 0.625rem 2.5rem rgba(0,0,0,0.2);">
            <div cdkDragHandle class="modal-header d-flex align-items-center justify-content-between"
              style="background-color: #008080; padding: 1rem 1.25rem; border-top-left-radius: 0.75rem; border-top-right-radius: 0.75rem;">
              <h5 class="modal-title font-weight-bold" style="color: white; font-size: 1rem; margin: 0;">
                <i class="fas fa-lock" style="margin-right: 0.375rem;"></i> Verify Customer Mobile
              </h5>
              <button type="button" (click)="onOTPModelClose()" class="close" data-dismiss="modal" aria-label="Close"
                style="outline: none; font-size: 1.375rem; padding: 0; margin: 0; line-height: 1; color: white; opacity: 1; text-shadow: none;">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body px-3 pt-3 pb-3">
              <form #loginotp="ngForm" novalidate>

                <div class="text-center mb-3">
                  <p class="mb-2" style="color: #64748b; font-size: 0.8125rem;">6-digit OTP sent to</p>
                  <div class="d-flex align-items-center justify-content-center mt-2">
                    <div
                      style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 0.375rem; padding: 0.25rem 0.625rem; display: flex; align-items: center;">
                      <span class="font-weight-bold" style="color: #334155; font-size: 0.875rem; letter-spacing: 1px;">
                        +91 {{ customerPhoneNo ? '*******' + (customerPhoneNo | slice:-3) : '' }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center mb-3" style="gap: 0.5rem;"
                  [ngClass]="{'shake': otpValidationState === 'error', 'pulse': otpValidationState === 'success'}">
                  <input type="text" id="otp1" name="otp1" [(ngModel)]="otp1" (keyup)="onOtpInput($event, 'otp2', '')"
                    numbersOnly maxlength="1" class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                  <input type="text" id="otp2" name="otp2" [(ngModel)]="otp2"
                    (keyup)="onOtpInput($event, 'otp3', 'otp1')" numbersOnly maxlength="1"
                    class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                  <input type="text" id="otp3" name="otp3" [(ngModel)]="otp3"
                    (keyup)="onOtpInput($event, 'otp4', 'otp2')" numbersOnly maxlength="1"
                    class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                  <input type="text" id="otp4" name="otp4" [(ngModel)]="otp4"
                    (keyup)="onOtpInput($event, 'otp5', 'otp3')" numbersOnly maxlength="1"
                    class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                  <input type="text" id="otp5" name="otp5" [(ngModel)]="otp5"
                    (keyup)="onOtpInput($event, 'otp6', 'otp4')" numbersOnly maxlength="1"
                    class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                  <input type="text" id="otp6" name="otp6" [(ngModel)]="otp6" (keyup)="onOtpInput($event, '', 'otp5')"
                    numbersOnly maxlength="1" class="form-control text-center otp-box"
                    [ngClass]="{'error-box': otpValidationState === 'error', 'success-box': otpValidationState === 'success'}">
                </div>

                <div style="height: 1.125rem; margin-bottom: 0.75rem; text-align: center;">
                  <div *ngIf="otpValidationState === 'error'" class="text-danger fade-in font-weight-bold"
                    style="font-size: 0.6875rem;">
                    <i class="fas fa-exclamation-circle"></i> Invalid OTP entered.
                  </div>
                  <div *ngIf="otpValidationState === 'success'" class="text-success fade-in font-weight-bold"
                    style="font-size: 0.6875rem;">
                    <i class="fas fa-check-circle"></i> Verification successful!
                  </div>
                </div>

                <button type="submit" (click)="onOTPModelOTP()" class="btn w-100 font-weight-bold"
                  style="background-color: var(--theme-primary); color: white; border-radius: 0.375rem; font-size: 0.875rem; padding: 0.625rem 0; transition: all 0.3s ease;"
                  [disabled]="OTP.length !== 6 || otpValidationState !== 'idle'" [class.spinner]="loading">
                  Verify & Proceed
                </button>

              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-right p-1">
        
        <button
          type="button"
          (click)="onSaveButtonClick()"
          class="btn font-size-12 button-btn"
          *ngIf="IsSave && Status != 'C'"
          [class.spinner]="loading"
          [disabled]="!f.form.valid || !isSaveLoanEnabled"
          
        >
          Save
        </button>
        <button
          type="button"
          (click)="onEditLoanInfo()"
          *ngIf="
            IsEdit &&
            (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)
          "
          class="btn font-size-12 button-btn"
          [disabled]="Status == 'C'"
          [class.spinner]="loading"
        >
          Edit
        </button>
        <button
          type="button"
          class="btn font-size-12 button-btn"
          (click)="SaveLoanInfo()"
          *ngIf="IsUpdate"
          [disabled]="!f.form.valid"

        >
          Update
        </button>
        <button
          type="button"
          (click)="CheckCustomerLoanInfo()"
          class="btn font-size-12 button-btn ml-3"
          *ngIf="!IsSave"
        >
          Next <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</form> -->

<!--Customer Details-->
<div *ngIf="dataCustomerSource && dataCustomerSource.length > 0" class="row m-0 mt-3">
  <div class="col-md-12 p-1">
    <div class="table-responsive">
      <mat-table [dataSource]="dataCustomerSource">
        <ng-container matColumnDef="Number">
          <mat-header-cell class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell"
            style="max-width: 3.125rem; max-height: 0.3125rem">
            {{ i + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CustomerId" style="display: none">
          <mat-header-cell class="grid-header" style="max-width: 6.25rem; max-height: 0.3125rem; display: none"
            *matHeaderCellDef>
            CustomerId
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell"
            style="max-width: 6.25rem; display: none; max-height: 0.3125rem">
            {{ row.CustomerId }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CustomerName">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Customer
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.CustomerName }}
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="CustomerType">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Customer Type</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{
                row.CustomerType == "Hirer" ? "Borrower" : row.CustomerType
                }}
              </mat-cell>
            </ng-container> -->

        <ng-container matColumnDef="GenderAge">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Gender/Age
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Gender }} / {{ row.Age }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="PhoneNo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>Phone No</mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            <div *ngIf="currentUser.IsMaskingMobile">
              {{ row.PhoneNo | mask }}
            </div>
            <div *ngIf="!currentUser.IsMaskingMobile">
              {{ row.PhoneNo }}
            </div>
            <!-- <i *ngIf="row.PhoneNoIsVerified.toLowerCase() == 'true'" class="fa fa-check-circle ml-2"
                  style="color: green"></i> -->
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="Relation_With_Hirer">
              <mat-header-cell class="grid-header" *matHeaderCellDef>
                Relation With Borrower
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{
                row.Relation_With_Hirer == "Own" ||
                row.Relation_With_Hirer == "OWN"
                ? "Self"
                : row.Relation_With_Hirer
                }}
              </mat-cell>
            </ng-container> -->
        <ng-container matColumnDef="RelationName">
          <mat-header-cell class="grid-header" *matHeaderCellDef>Relation</mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.RelationName }}
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="ExistingCustomer">
              <mat-header-cell class="grid-header" *matHeaderCellDef>
                Existing
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ExistingCustomer }}
              </mat-cell>
            </ng-container> -->
        <mat-header-row *matHeaderRowDef="displayedCustomerColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCustomerColumns"></mat-row>
      </mat-table>
    </div>
  </div>
</div>
<!--TAT Report moved to rightPart-->
<!-- <mat-paginator #paginatorRef [pageSizeOptions]="[50]" showFirstLastButtons> </mat-paginator> -->

<div class="modal fade in" id="proFilePicFull" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Profile Picture
        </h6>
        <button type="button" (click)="OnCloseProfile()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div style="
                padding: 0.4375rem;
                display: flex;
                justify-content: center;
                align-items: center;
              ">
          <img (click)="ProfilePicFullmodel()" style="
                  height: 80%;
                  width: 80%;
                  border-radius: 5%;
                  object-fit: cover;
                " src="{{ CustomerPicDetail }}" alt="Profile Pic" />
        </div>
      </div>
    </div>
  </div>
</div>
<app-digilocker-sdk #digilockerSdk1 [openmodel]="openmodel" (close)="onsdkSuccess($event)">
  <div>sdk added to customer entry 1</div>
</app-digilocker-sdk>

<app-digiosdk #digioSdk [digioresponse]="digioresponse" (close)="ondigioSDKSuccess($event)"></app-digiosdk>